import { BreakPointCondition, UI, useBreakpointIf, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';
import { FlatList } from 'react-native';

import { DirectTreasuryDetailsModalComponentsProps } from '../..';
import { parseDirectTreasuryContentHorizontalData } from '../../constants';

export const DirectTreasuryDetailsInfos = ({
  item: directTreasury,
  directTreasuryMarketStatus,
}: DirectTreasuryDetailsModalComponentsProps) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  const columns = isMobile ? 2 : 3;

  if (!directTreasuryMarketStatus) {
    return <></>;
  }

  return (
    <FlatList
      key={columns}
      testID={'direct-treasury-content-horizontal-list'}
      data={parseDirectTreasuryContentHorizontalData(
        directTreasury,
        directTreasuryMarketStatus.marketStatus
      )}
      contentContainerStyle={{ rowGap: 16 }}
      showsVerticalScrollIndicator={false}
      keyExtractor={(item) => item.label}
      numColumns={columns}
      renderItem={({ item }) => {
        const valueIsText = typeof item.value === 'string';

        const valueItemText = (
          <UI.Text color={'neutral.black'} variant="regular" fontSize={Typography['fontsize.md']}>
            {item.value}
          </UI.Text>
        );

        const valueItemComponent = item.value;

        const itemValue = valueIsText ? valueItemText : valueItemComponent;

        return (
          <VStack flex={1} space={Spacing['inset.quarck']}>
            <UI.Text
              color={'neutral.black'}
              variant="semibold"
              fontSize={Typography['fontsize.xs']}>
              {item.label}
            </UI.Text>
            {itemValue}
          </VStack>
        );
      }}
    />
  );
};
